import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import LabeledContainer from '../../../../../../../molecules/common/LabeledContainer';
import TextInput, { TextInputType } from '../../../../../../../atoms/TextInput';
import { Survey } from '../../../../../../../interfaces/merchants/resources/books';
import ErrorMessage from '../../../../../../../molecules/merchant/resources/book/InputUserInfoErrorMessage/InputUserInfoErrorMessage';

interface Props {
  survey: Survey;
  onChange: (name: string, value: string) => void;
  name: string;
  value: string;
}

const sanitize = (s: string): string => s.replace(/\r\n?/g, '\n');

export const submittable = (survey?: Survey, value?: string): boolean => {
  if (!survey) {
    return true;
  }
  if (!survey.required) {
    return true;
  }
  if (!!survey.question) {
    if (!!value) {
      return !!value && sanitize(survey.question) !== sanitize(value);
    }
  }
  return !!value;
};

const InputUserInfoSurvey: React.FC<Props> = (props) => {
  const { survey, name, value, onChange } = props;
  const intl = useIntl();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const {
        currentTarget: { name, value },
      } = e;
      onChange(name, value);
    },
    [onChange],
  );

  return (
    <div>
      <LabeledContainer
        label={intl.formatMessage({ id: `books.formsLabel.survey` })}
        paddingTop={true}
        requiredLabel={survey.required}
        errorStyle={survey.errors && survey.errors.length !== 0}
      >
        <TextInput
          type={TextInputType.TextArea}
          name={name}
          value={value || ''}
          // @ts-expect-error strictFunctionTypes
          onChange={handleChange}
          placeholder={survey.question}
        />
      </LabeledContainer>
      <ErrorMessage fieldSource={survey} />
    </div>
  );
};

export default InputUserInfoSurvey;
